// Comped athletes — attend without spending sessions.
//
// Some juniors attend free (a volunteer coach's children, for example). Before
// this flag the only way to express that was topping their balance up by hand,
// which drifts negative and then reads as debt everywhere sessions are shown.
//
// A comped athlete is never charged a session and never chased for a low
// balance. Their stored sessionBalance is left untouched rather than zeroed, so
// removing the flag restores whatever they had.
export function isComped(athlete) {
  return athlete?.compedSessions === true;
}

/** What to show in a "sessions" column. */
export function sessionLabel(athlete) {
  if (isComped(athlete)) return 'Comp';
  const n = athlete?.sessionBalance ?? 0;
  return `${n}`;
}

/**
 * What a check-in spends: nothing for a comped athlete, otherwise one session.
 *
 * The delta rather than the result, because balances are written with
 * increment() — the client cannot know the true balance without re-reading,
 * and computing one from a stale read is how a session goes missing when two
 * people check the same athlete in at once.
 */
export function sessionCost(athlete) {
  return isComped(athlete) ? 0 : 1;
}

/**
 * Balance after a check-in. Comped athletes are unchanged, so callers can
 * write this back unconditionally.
 *
 * Still used for the optimistic on-screen number and the balanceAfter recorded
 * on the attendance row; the authoritative write goes through sessionCost.
 * Derived from the same helper so the two cannot drift.
 */
export function balanceAfterCheckIn(athlete) {
  const current = athlete?.sessionBalance || 0;
  return current - sessionCost(athlete);
}

/** Whether a zero balance should block this athlete from self-check-in. */
export function blockedByBalance(athlete) {
  return !isComped(athlete) && (athlete?.sessionBalance || 0) <= 0;
}
